import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

export const ClaimBtn = styled(Button)({
  height: "48px",
  lineHeight: "48px",
  maxHeight: "48px",
  color: "#14D1B2",
  fontSize: 14,
  width: "100%",
  fontFamily: "Gilroy-Bold",
  textTransform: "uppercase",
  background: "rgba(20, 209, 178, 0.2)",
  border: "none",
  borderRadius: "8px",
  "&:hover": {
    background: "rgba(20, 209, 178, 0.5)",
    color: "#14D1B2",
  },
});
